import {createFileRoute} from '@tanstack/react-router';
import {DepositAccountCloseInfoPage} from '../../../../../../features/deposit/pages/DepositAccountCloseInfoPage';

export const Route = createFileRoute(
  '/_protected/accounts/deposits/$accountId/close/',
)({
  component: DepositAccountCloseInfoPage,
});
